module.exports = __webpack_public_path__ + "img/202410_02.4667bda1.jpg";